let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hqvIQ")).then(() => parcelRequire('2dBQ9'));